import { CustomMessageFilterEntity } from '../../domain/entities/CustomMessageFilterEntity'
import type { Language } from '@/shared/enums/languagesEnum'
import type { UserAppType } from '../../domain/enums/UserAppType'

/**
 * The API query contract for GET /api/admin/v1/custommessages.
 * Keep this separate from the table's presentation filter state so that UI
 * values (notably JavaScript Date instances) never leak into the URL.
 */
export class CustomMessageFilterModel {
  title?: string
  regionId?: number
  userIds?: string[]
  language?: Language
  mobileAppType?: UserAppType
  startAt?: string
  endAt?: string
  page?: number
  limit?: number

  constructor(dataDto: CustomMessageFilterEntity) {
    this.title = normalizeTitle(dataDto.title)
    this.regionId = dataDto.region?.id
    this.userIds = dataDto.users?.map((item) => item.id).filter((id): id is string => !!id)
    this.language = dataDto.language
    this.mobileAppType = dataDto.mobileAppType
    this.startAt = toIsoDateTime(dataDto.startDate)
    this.endAt = toIsoDateTime(dataDto.expirationDate, true)
    this.page = dataDto.page
    this.limit = dataDto.limit
  }
}

function normalizeTitle(value?: string): string | undefined {
  const title = value?.trim()
  return title && title.length <= 100 ? title : undefined
}

function toIsoDateTime(value?: string | Date, endOfDay = false): string | undefined {
  if (!value) return undefined

  const date = new Date(value)
  if (endOfDay) {
    date.setHours(23, 59, 59, 999)
  }

  return Number.isNaN(date.getTime()) ? undefined : date.toISOString()
}
